<div class="loading-section" [class.loading-section--fit-content]="type() === 'fit-content'">
  <div class="loading-content">
    <img src="assets/icons/spinner-loading.svg" alt="" aria-hidden="true" class="loading-spinner" />
    <p class="loading-message" role="loading">{{ message() | translate }}</p>
  </div>
</div>
